var _style, _circle, _g, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFooterFortune(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 177 61.5",
    style: {
      enableBackground: "new 0 0 177 61.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#26A9E0;}\n\t.st2{font-family:'BMJUAOTF';}\n\t.st3{font-size:8.4582px;}\n\t.st4{letter-spacing:1;}\n\t.st5{fill:#1B75BB;}\n\t.st6{font-family:'Humanist777BT-BlackItalicB';}\n\t.st7{font-size:28.194px;}\n\t.st8{fill:url(#SVGID_1_);}\n\t.st9{fill:url(#SVGID_00000026864850244981869270000000209287773191671481_);}\n\t.st10{fill:url(#SVGID_00000158716764308751719450000017044432590905646223_);}\n\t.st11{fill:url(#SVGID_00000156559821666600220990000004515758798801130372_);}\n\t.st12{fill:url(#SVGID_00000031174424263005003710000005466230832290984375_);}\n\t.st13{fill:url(#SVGID_00000127041287272344369170000004388899245271069062_);}\n\t.st14{fill:url(#SVGID_00000077322451833264998350000011309685230069855648_);}\n\t.st15{fill:url(#SVGID_00000077283244119772585680000006893235340410500770_);}\n\t.st16{fill:url(#SVGID_00000119804745830040649930000009460002491380913333_);}\n\t.st17{fill:url(#SVGID_00000133513822621239846540000000868077547047289478_);}\n\t.st18{fill:url(#SVGID_00000048486210704009810450000003120929168521010339_);}\n\t.st19{fill:url(#SVGID_00000042717235231053617600000012151621703779762110_);}\n\t.st20{fill:url(#SVGID_00000109745579308000207470000004090456838880175005_);}\n\t.st21{fill:url(#SVGID_00000142167637532553499310000004695696879966639282_);}\n\t.st22{fill:url(#SVGID_00000112622109735966108140000016817046301749926584_);}\n\t.st23{fill:url(#SVGID_00000022554445006508949920000009223827309225352844_);}\n\t.st24{fill:url(#SVGID_00000067215275602522876470000014546009932418877611_);}\n\t.st25{fill:url(#SVGID_00000111909858128104322550000001341105460580198558_);}\n\t.st26{fill:url(#SVGID_00000110462560324716520960000001224381762608656563_);}\n\t.st27{fill:url(#SVGID_00000160911059766684190120000010085109813414739105_);}\n\t.st28{opacity:0.12;}\n\t.st29{fill:url(#SVGID_00000036929577154784162590000007868634495291570878_);}\n\t.st30{fill:url(#SVGID_00000089573115987011058380000002876494241077267340_);}\n\t.st31{fill:url(#SVGID_00000054983930341720682310000005837166201668876214_);}\n\t.st32{fill:url(#SVGID_00000000182648813293358900000000513832974473502655_);}\n\t.st33{fill:url(#SVGID_00000171702951212620176230000016474331705899457952_);}\n\t.st34{fill:url(#SVGID_00000163780845981252418980000000163249357346965415_);}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26.8,
    cy: 27.4,
    r: 22
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 64.5685 38.4087)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st1 st2 st3 st4"
  }, "ACCOUNTING &amp;"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10.1,
    className: "st1 st2 st3 st4"
  }, "TAXATION SERVICES")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 62.506 25.5035)",
    className: "st5 st6 st7"
  }, "Fortune"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 65.1674,
    cy: 88.7416,
    r: 22.1017,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -19.4665 -72.1963)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#929497",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5313,
    style: {
      stopColor: "#949699",
      stopOpacity: 0.318
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#9B9DA0",
      stopOpacity: 0.4559
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7908,
    style: {
      stopColor: "#A8AAAC",
      stopOpacity: 0.5587
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8828,
    style: {
      stopColor: "#B9BBBD",
      stopOpacity: 0.644
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8892,
    style: {
      stopColor: "#BBBDBF",
      stopOpacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBBDBF",
      stopOpacity: 0.95
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 27.6,
    cy: 27.3,
    r: 22.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159458888716925226120000010356682897477830074_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.3796,
    y1: 87.6752,
    x2: 91.1676,
    y2: 87.6752,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -19.4665 -72.1963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159458888716925226120000010356682897477830074_)"
    },
    d: "M27,0c0,0,20.7,1.3,25.6,19.2 c4.9,17.8-7.7,30.6-21.4,34c0,0,11.2-7.4,2.3-24l6.4-1.8c0,0,3-0.9,1.4-5.2c-1.6-4.2-2-4.7-2-4.7s-1-1.4-3.6-0.4 c-3.9,1.4-4.4,1.7-4.4,1.7S29,12.5,27.6,6.9C27,4.4,27,2.4,27,0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158721348077165423460000003312196045078565055_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.5994,
    y1: 68.1149,
    x2: 77.1896,
    y2: 86.705,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -19.4665 -72.1963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158721348077165423460000003312196045078565055_)"
    },
    d: "M25.7,9.4l3.6,11.8c0,0,5.3-1.7,6.2-2.1 s1.9,0.9,1.9,0.9s3.2,3.5,1.4,7.8c0,0,4.1-0.5,3.1-4.1c-1.2-4.2-2.6-6.1-2.6-6.1S38.2,16,35.6,17c-3.4,1.3-4.3,1.9-4.3,1.9 L27.2,4.4L25.7,9.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140010441662104430280000018304527290705674142_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.3407,
    y1: 101.8392,
    x2: 71.4006,
    y2: 101.8392,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -19.4665 -72.1963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140010441662104430280000018304527290705674142_)"
    },
    d: "M33.7,29.7c0,0,3.7,12.3-2.7,19 c-4.6,4.9,1.2,8,4.9-1.5C39.4,38.4,33.7,29.7,33.7,29.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145764322168878749270000010860095527656426651_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.4116,
    y1: 89.443,
    x2: 68.8832,
    y2: 89.443,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -19.4665 -72.1963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145764322168878749270000010860095527656426651_)"
    },
    d: "M22.2,6.1c0,0-9.6,3.5-3.5,17.8 S29.6,43.6,26,53.5C26,53.5,4.2,53,0.6,32C-3.8,6.3,21,0.3,21.1,0.8C21.2,1.1,22.2,6.1,22.2,6.1z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,18.8c0,0-3.1,9,9,21.8c0,0-4.6-1.1-5.4-2.7c0,0-0.1,1.7,0.9,3.2C12.6,41.1,3,31.8,8.1,18.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.4,34.2c0,0,3.4-8.9-8.3-22c0,0,4.5,1.3,5.3,2.9c0,0,0.1-1.7-0.8-3.2C45.6,11.8,54.9,21.3,49.4,34.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039133811035372085290000002812337260731741839_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.7886,
    y1: 88.7416,
    x2: 69.0072,
    y2: 88.7416,
    gradientTransform: "matrix(0.9817 0.1904 -0.1904 0.9817 -19.4665 -72.1963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03002062,
    style: {
      stopColor: "#554B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4147,
    style: {
      stopColor: "#5A6DAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#5C75B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7819,
    style: {
      stopColor: "#70B8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#73BEDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76C5DF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039133811035372085290000002812337260731741839_)"
    },
    d: "M21.1,0.8c0,0-11.8,9.7-3,23.7 s8.3,28,8.3,28s4.6-7.2-7.2-29.7c0,0-5.8-11.3,3-16.6L21.1,0.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000176020616365695444400000005283956479982472064_",
    cx: 27.4604,
    cy: 60.57,
    r: 12.8028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07491276,
    style: {
      stopColor: "#BBBDBF",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2894,
    style: {
      stopColor: "#BEC0C2",
      stopOpacity: 0.4033
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    style: {
      stopColor: "#C6C8CA",
      stopOpacity: 0.4695
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5427,
    style: {
      stopColor: "#D5D7D8",
      stopOpacity: 0.5253
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    style: {
      stopColor: "#EAEBEC",
      stopOpacity: 0.575
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6588,
    style: {
      stopColor: "#EDEEEF",
      stopOpacity: 0.5812
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    style: {
      stopColor: "#EBEAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EAEB"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000176020616365695444400000005283956479982472064_)"
    },
    cx: 27.5,
    cy: 60.6,
    rx: 18.1,
    ry: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooterFortune);
export default __webpack_public_path__ + "static/media/logo-footer_Fortune.0a03245fdbe5ff6af29f71a59d2e1796.svg";
export { ForwardRef as ReactComponent };